module.exports = __webpack_public_path__ + "static/media/gimli.dbd78fe3.png";